import { createGetEndpoint } from '@sonar-software/sonar-http';
import { OidcSubdomainConfiguration } from '@types';

export type GetOidcConfigurationsForCurrentSubdomainResponse = Array<OidcSubdomainConfiguration>;

export const getOidcConfigurationsForCurrentSubdomain =
	createGetEndpoint<void, GetOidcConfigurationsForCurrentSubdomainResponse>('/api/v2/oidc/config');
